import React from 'react';
import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';
import Icon from '../Icon';
import { NavItem } from './types';

interface TabNavLinkProps {
  item: NavItem;
  /** rail: tablet side rail (56×32 pill, 12px label) · bar: mobile bottom bar (52×30 pill, 11px label). */
  variant: 'rail' | 'bar';
}

/** Icon-over-label nav item used by the tablet rail and the mobile tab bar. */
export const TabNavLink: React.FC<TabNavLinkProps> = ({ item, variant }) => (
  <NavLink
    to={item.to}
    className={({ isActive }) =>
      cn(
        'tw-group tw-flex tw-flex-col tw-items-center tw-gap-1 tw-rounded-xl focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ds-brand',
        variant === 'rail' ? 'tw-w-full tw-py-1.5' : 'tw-min-w-0 tw-flex-1 tw-py-0.5',
        isActive ? 'tw-text-ds-brand-text' : 'tw-text-ds-text-secondary',
      )
    }
  >
    {({ isActive }) => (
      <>
        <span
          className={cn(
            'tw-flex tw-items-center tw-justify-center tw-transition-colors',
            variant === 'rail' ? 'tw-h-8 tw-w-14 tw-rounded-2xl' : 'tw-h-[30px] tw-w-[52px] tw-rounded-[15px]',
            isActive ? 'tw-bg-ds-brand-tint' : 'group-hover:tw-bg-ds-subtle',
          )}
        >
          <Icon icon={item.icon} size={22} />
        </span>
        <span
          className={cn(
            'tw-whitespace-nowrap',
            variant === 'rail' ? 'tw-text-[12px] tw-leading-4' : 'tw-text-[11px] tw-leading-[14px]',
            isActive ? 'tw-font-semibold' : 'tw-font-medium',
          )}
        >
          {item.shortLabel}
        </span>
      </>
    )}
  </NavLink>
);
